import { memo, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { ToastContainer } from 'react-toastify'
import styled from 'styled-components'
import 'react-toastify/dist/ReactToastify.css'

const NotificationContainer = memo(() => {
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
		return () => setMounted(false)
	}, [])

	return mounted
		? createPortal(
				<>
					<StyledToastContainer
						icon={() => null}
						containerId="notifications"
						position="top-right"
						autoClose={10000}
						closeOnClick={false}
					/>
				</>,
				document.body
			)
		: null
})

const StyledToastContainer = styled(ToastContainer)`
	.Toastify__toast-container {
		border-radius: 6px 6px 3px 3px;
		padding: 15px;
	}
	width: 340px;
	padding: 0;
	.Toastify__toast {
		background: ${(props) => props.theme.colors.selectedTheme.newTheme.containers.cards.background};
		padding: 20px;
		border-radius: 8px;
		border: 1px solid ${(props) => props.theme.colors.selectedTheme.newTheme.border.color};
		box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.4);
	}

	@media (max-width: 480px) {
		top: 10px;
		left: auto;
	}

	.Toastify__toast-body {
		font-weight: 600;
		font-size: 14px;
		line-height: 14px;
		overflow-wrap: break-word;
		word-break: break-word;
		padding: 0;
		margin-right: -14px;
	}
	.Toastify__progress-bar {
		height: 3px;
	}
	.Toastify__close-button > svg {
		fill: ${(props) => props.theme.colors.selectedTheme.newTheme.banner.default.text};
	}

	.successBody {
		color: ${(props) => props.theme.colors.selectedTheme.newTheme.text.positive};
	}

	.successProgress {
		background: ${(props) => props.theme.colors.selectedTheme.newTheme.text.positive};
	}

	.pendingBody {
		color: ${(props) => props.theme.colors.selectedTheme.newTheme.text.primary};
	}

	.pendingProgress {
		background: ${(props) => props.theme.colors.selectedTheme.newTheme.text.primary};
	}

	.failBody {
		color: ${(props) => props.theme.colors.selectedTheme.newTheme.text.negative};
	}

	.failProgress {
		background: ${(props) => props.theme.colors.selectedTheme.newTheme.text.negative};
	}
`

export default NotificationContainer
